import { lazy, Suspense, useEffect, useRef } from "react";
import { useScroll } from "@/animation/gsap-motion";
import { AirHeader } from "@/components/air/AirHeader";
import { AirIntroHero } from "@/components/air/AirIntroHero";
import { LandingSky } from "@/components/air/LandingSky";
import { useSiteLocale } from "@/components/site/useSiteLocale";
import { landingStyles as styles } from "@/styles/classes";
import { useSkyTheme } from "@/theme/sky-theme-core";
import "@/styles/landing-typography.css";
import "@/styles/landing-font.css";

const AirNarrative = lazy(async () => ({ default: (await import("@/components/air/AirNarrative")).AirNarrative }));
const AirFinalCTA = lazy(async () => ({ default: (await import("@/components/air/AirFinalCTA")).AirFinalCTA }));

export function LandingPage() {
  const finaleRef = useRef<HTMLDivElement>(null);
  const { locale, toggleLocale } = useSiteLocale("en");
  const { tone } = useSkyTheme();
  const { scrollYProgress: footerProgress } = useScroll({
    target: finaleRef,
    offset: ["start end", "end end"],
  });

  useEffect(() => {
    document.documentElement.lang = locale === "zh" ? "zh-CN" : "en";
  }, [locale]);

  return (
    <main className={styles.page} lang={locale === "zh" ? "zh-CN" : "en"}>
      <LandingSky locale={locale} footerProgress={footerProgress} />
      <AirHeader
        locale={locale}
        introComplete
        onLocaleChange={toggleLocale}
      />
      <div className={styles.content}>
        <AirIntroHero
          locale={locale}
          onLocaleChange={toggleLocale}
        />
        <Suspense fallback={null}>
          <AirNarrative locale={locale} />
        </Suspense>
        <div ref={finaleRef}>
          <Suspense fallback={null}>
            <AirFinalCTA locale={locale} tone={tone} />
          </Suspense>
        </div>
      </div>
    </main>
  );
}
